import { RouteStub } from "@/components/RouteStub";

/**
 * Route "attrape-tout" (`*`) sans équivalent direct dans apps/web (Next.js
 * gère le 404 via `app/not-found.tsx`, absent du répertoire à ce jour) —
 * ajout pur, pour éviter un écran blanc sur une URL inconnue.
 */
export function NotFoundPage() {
  return <RouteStub name="Page introuvable (404)" path="*" />;
}
